import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import { HeaderMedium } from '../../components/UISystem/Typography';
import { BottomSheetExample } from '../../components/UISystem/Overlays';

/**
 * OverlaysScreen Component
 *
 * Showcases the Overlays components in the UI System
 */
const OverlaysScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      <div style={UI_SCREEN_STYLES.header}>
        <IconBack onClick={onBack} />
        <h1 style={UI_SCREEN_STYLES.title}>Overlays</h1>
      </div>
      <div style={UI_SCREEN_STYLES.divider}></div>

      <div style={UI_SCREEN_STYLES.content}>
        <HeaderMedium style={{ marginBottom: '16px' }}>BottomSheet</HeaderMedium>
        <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: 'bold' }}>default</div>
        <BottomSheetExample />
      </div>
    </div>
  );
};

export default OverlaysScreen;
